import { render, staticRenderFns } from "./Questions.vue?vue&type=template&id=4d3a91b6&scoped=true&"
import script from "./Questions.vue?vue&type=script&lang=ts&"
export * from "./Questions.vue?vue&type=script&lang=ts&"
import style0 from "./Questions.vue?vue&type=style&index=0&id=4d3a91b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3a91b6",
  null
  
)

export default component.exports